import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=26306136&scoped=true&"
import script from "./AuditLogs.vue?vue&type=script&lang=js&"
export * from "./AuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=26306136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26306136",
  null
  
)

export default component.exports